import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import AzImg from '~/components/Atoms/AzImg.vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import { useGetTranslations } from '~/composables/useGetTranslations';
import PriceDisplay from '~/components/Atoms/PriceDisplay.vue';
import getImgByLabel from '~/utils/getImgByLabel';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CartPopupNotification',
  props: {
    items: {
      type: Array,
      default: function _default() {
        return null;
      }
    },
    priceTotal: {
      type: Number,
      default: null
    },
    articlesCount: {
      type: Number,
      default: null
    }
  },
  emits: ['close', 'open-cart'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var articleText = computed(function () {
      return props.articlesCount > 1 ? 'addToCart.pluralArticles' : 'addToCart.singularArticle';
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      translate: translate,
      articleText: articleText,
      AzImg: AzImg,
      AzButton: AzButton,
      PriceDisplay: PriceDisplay,
      getImgByLabel: getImgByLabel,
      AzIcon: AzIcon
    };
  }
});